import { render, staticRenderFns } from "./AdminProductsView.vue?vue&type=template&id=bcbdd59a&scoped=true"
import script from "./AdminProductsView.vue?vue&type=script&lang=js"
export * from "./AdminProductsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcbdd59a",
  null
  
)

export default component.exports